import { createSlice } from '@reduxjs/toolkit';
import { Service } from 'services/Services';
import { RequestApi } from 'RequestApi';
import { NotificationMessage } from 'components/notification-message/NotificationMessage';
import { setViewingRecord } from 'components/dynamic/dynamic-page/DynamicPageRecordSlice';

const initialState = {
  formLoading: false,
  record: null,
  pageInfo: null,
  progressing: false,
};

const attendanceHistoryRecordDetailSlice = createSlice({
  name: 'attendanceHistoryRecordDetail',
  initialState,
  reducers: {
    setPageInfo(state, action) {
      state.pageInfo = action.payload;
    },
    setFormLoading(state, action) {
      state.formLoading = action.payload;
    },
    setRecord(state, action) {
      state.record = action.payload;
    },
    setProgressing(state, action) {
      state.progressing = action.payload;
    },
  },
});

const { setPageInfo, setFormLoading } = attendanceHistoryRecordDetailSlice.actions;

export const { setRecord } = attendanceHistoryRecordDetailSlice.actions;

export const initPageInfo =
  ({ informationPage, document, startingDate = '', endingDate = '' }) =>
  async (dispatch) => {
    try {
      dispatch(setFormLoading(true));
      dispatch(setPageInfo(informationPage));
      let url = `${informationPage.url}/index-info?`;
      url += `auth_token=${Service.userToken}`;
      const data = JSON.stringify({
        data_unid: document.id,
        starting_date: startingDate,
        ending_date: endingDate,
      });

      RequestApi(url, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            dispatch(setRecord(res.data));
            if (!document.status) {
              dispatch(setViewingRecord(res.data.record));
            }
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }

          dispatch(setFormLoading(false));
        })
        .catch((err) => {
          console.log(err);
          dispatch(setFormLoading(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setFormLoading(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

const attendanceHistoryRecordDetailSliceReducer = attendanceHistoryRecordDetailSlice.reducer;

export default attendanceHistoryRecordDetailSliceReducer;
